import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
});
